import gameAssets from "@themed-assets";
import React from "react";
import {
  checkToDisplayValueInK,
  checkToDisplayValueInL,
  parseDecimalValuesOfNumber,
  checkToDisplayValueInCr,
} from "@/Common/utils/GameUtils";
import TicketIcon from "@/src/assets/TicketIcon";
import RupeeIcon from "@/src/assets/RupeeIcon";

function TourneyDetailsPrizes({ selectedTourneyDetails }) {
  const {
    nextPrizeJumpRank = 0,
    nextPrizeAmount,
    breakEven,
    dynamicPoolPrize,
    prizePool,
    prizePoolTickets,
    totalWinners,
  } = selectedTourneyDetails;

  return (
    <div className="">
      <div className="bg-radial-[at_44%_25%] to-50% to-foreground/90 from-accent/80 rounded-300 flex items-center px-4 pt-4 pb-2.5">
        <div
          className={`flex justify-center drop-shadow-2xl drop-shadow-warning/40`}
          style={{ flex: 0.4 }}
        >
          <img src={gameAssets.TrophyLargeIcon} className="object-cover" />
        </div>
        <div className={`flex flex-col items-center`} style={{ flex: 0.5 }}>
          <div className="text-xs text-secondary pl-4 font-normal mb-1">
            Prize Pool
          </div>
          <div className="flex items-center gap-x-1.5 pl-4">
            {((breakEven && dynamicPoolPrize > 0) || prizePool > 0) && (
              <div className={`flex items-center`}>
                <RupeeIcon />
                <div className="text-base text-gold-primary font-bold">
                  {/* {selectedTourneyDetails?.prizePool || 0} */}
                  {breakEven
                    ? dynamicPoolPrize > 0
                      ? `${parseDecimalValuesOfNumber(
                          dynamicPoolPrize,
                          2,
                          checkToDisplayValueInK(dynamicPoolPrize),
                          checkToDisplayValueInL(dynamicPoolPrize),
                          checkToDisplayValueInCr(dynamicPoolPrize)
                        )}`
                      : ""
                    : prizePool > 0
                    ? `${parseDecimalValuesOfNumber(
                        prizePool,
                        2,
                        checkToDisplayValueInK(prizePool),
                        checkToDisplayValueInL(prizePool),
                        checkToDisplayValueInCr(prizePool)
                      )}`
                    : ""}
                </div>
              </div>
            )}
            {prizePoolTickets > 0 && (
              <div className={`flex items-center`}>
                {((breakEven && dynamicPoolPrize > 0) || prizePool > 0) && (
                  <div className={`text-base font-bold text-gold-primary ml-1`}>
                    +
                  </div>
                )}
                <TicketIcon count={prizePoolTickets} />
                <div className={`text-base font-bold text-gold-primary`}>
                  Ticket{prizePoolTickets > 1 ? "s" : ""}
                </div>
              </div>
            )}
          </div>
          <div className="flex items-center justify-center mt-3 pl-4 w-full">
            <div className={`flex flex-col items-center`} style={{ flex: 0.5 }}>
              <div className="text-xs text-secondary font-normal mb-1">
                Placed Paid
              </div>
              <div className="text-xs text-primary font-medium">
                {/* {selectedTourneyDetails?.totalWinners || 0} */}
                {parseDecimalValuesOfNumber(
                  totalWinners,
                  2,
                  checkToDisplayValueInK(totalWinners),
                  checkToDisplayValueInL(totalWinners),
                  checkToDisplayValueInCr(totalWinners)
                )}
              </div>
            </div>
            {nextPrizeJumpRank > 0 &&
              nextPrizeAmount &&
              nextPrizeAmount?.amount > 0 && (
                <div
                  className={`flex flex-col items-center`}
                  style={{ flex: 0.5 }}
                >
                  <div className="text-xs text-secondary font-normal mb-1">
                    Next Payout
                  </div>
                  <div className={`flex items-center`}>
                    <div className="text-xs text-primary font-medium">{`₹ ${parseDecimalValuesOfNumber(
                      nextPrizeAmount.amount + nextPrizeAmount.bonus,
                      2,
                      checkToDisplayValueInK(
                        nextPrizeAmount.amount + nextPrizeAmount.bonus
                      ),
                      checkToDisplayValueInL(
                        nextPrizeAmount.amount + nextPrizeAmount.bonus
                      ),
                      checkToDisplayValueInCr(
                        nextPrizeAmount.amount + nextPrizeAmount.bonus
                      )
                    )}`}</div>
                    {nextPrizeAmount.ticket && (
                      <div className="inline-flex items-center  ml-1">
                        {nextPrizeAmount.amount > 0 ? "+" : ""}
                        <TicketIcon count={1} />
                      </div>
                    )}
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>

      {/* section 2 */}
      <div className="bg-foreground/60 text-white rounded-300 p-3 space-y-2 mt-4">
        <div
          className={`flex items-center justify-between px-4 py-2 rounded-md `}
        >
          <div className="text-xs text-secondary w-2/6 font-bold">RANK</div>
          <div className="text-xs text-secondary w-4/6 font-bold">PRIZE</div>
        </div>

        {selectedTourneyDetails?.winnersPayoutWithBonus &&
          Object.keys(selectedTourneyDetails?.winnersPayoutWithBonus).map(
            (payout, index) => (
              <div
                className={`${
                  selectedTourneyDetails?.winnersPayoutWithBonus
                    ?.nextPrizeJumpRank == payout
                    ? "border pt-5 pb-3 border-link/60"
                    : "py-3"
                } rounded-300 relative overflow-hidden px-2 bg-accent/20`}
              >
                {/* {index == 2 ? ( */}
                {selectedTourneyDetails?.winnersPayoutWithBonus
                  ?.nextPrizeJumpRank == payout ? (
                  <div className="absolute top-0 left-0">
                    <div
                      className={`text-2xs font-medium bg-link/60 px-2 py-0.5 rounded-br`}
                    >
                      Next Payout
                    </div>
                  </div>
                ) : (
                  <div />
                )}
                <div
                  key={index}
                  className={`flex items-center justify-between px-3 py-4s rounded font-medium text-primary`}
                >
                  <div className="text-sm font-bold text-primary w-2/6">
                    {
                      Object.keys(
                        selectedTourneyDetails?.winnersPayoutWithBonus
                      )[index]
                    }
                  </div>

                  <div className="text-sm font-bold text-primary w-4/6">
                    <div className={`flex items-center`}>
                      <span className="inline-flex items-center gap-1">
                        {selectedTourneyDetails?.winnersPayoutWithBonus[payout]
                          ?.amount > 0 &&
                          `₹${parseDecimalValuesOfNumber(
                            selectedTourneyDetails?.winnersPayoutWithBonus[
                              payout
                            ]?.amount,
                            2,
                            checkToDisplayValueInK(
                              selectedTourneyDetails?.winnersPayoutWithBonus[
                                payout
                              ]?.amount
                            ),
                            checkToDisplayValueInL(
                              selectedTourneyDetails?.winnersPayoutWithBonus[
                                payout
                              ]?.amount
                            ),
                            checkToDisplayValueInCr(
                              selectedTourneyDetails?.winnersPayoutWithBonus[
                                payout
                              ]?.amount
                            )
                          )}`}
                      </span>
                      {selectedTourneyDetails?.winnersPayoutWithBonus[
                        `${payout}`
                      ]?.bonus > 0 && (
                        <span className="inline-flex items-center gap-1">
                          {selectedTourneyDetails?.winnersPayoutWithBonus[
                            payout
                          ]?.amount > 0
                            ? ` + `
                            : ""}
                          {`IB ${parseDecimalValuesOfNumber(
                            selectedTourneyDetails?.winnersPayoutWithBonus[
                              `${payout}`
                            ]?.bonus,
                            2,
                            checkToDisplayValueInK(
                              selectedTourneyDetails?.winnersPayoutWithBonus[
                                `${payout}`
                              ]?.bonus
                            ),
                            checkToDisplayValueInL(
                              selectedTourneyDetails?.winnersPayoutWithBonus[
                                `${payout}`
                              ]?.bonus
                            ),
                            checkToDisplayValueInCr(
                              selectedTourneyDetails?.winnersPayoutWithBonus[
                                `${payout}`
                              ]?.bonus
                            )
                          )}`}
                        </span>
                      )}
                      {selectedTourneyDetails?.winnersPayoutWithBonus[
                        `${payout}`
                      ]?.ticket && (
                        <div className="inline-flex items-center  ml-1">
                          {selectedTourneyDetails?.winnersPayoutWithBonus[
                            payout
                          ]?.amount > 0 ||
                          selectedTourneyDetails?.winnersPayoutWithBonus[
                            `${payout}`
                          ]?.bonus > 0
                            ? "+"
                            : ""}
                          {/* <img className="" src={gameAssets.TicketIcon} /> */}
                          <TicketIcon count={1} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
      </div>
    </div>
  );
}

export default TourneyDetailsPrizes;

const players = [
  { rank: 1, name: "minlunch", stack: "1,000", chip: "🃏" },
  { rank: 2, name: "minlunch", stack: "1,000", chip: "🃏" },
  { rank: 3, name: "minlunch", stack: "1,000", chip: "🃏" },
  {
    rank: 4,
    name: "sycamorev anquished few fewfew ",
    stack: "₹1,000",
    chip: "🍗",
  },
  { rank: 4, name: "sycamorevanquished", stack: "1,000", chip: "🍗" },
  { rank: 4, name: "sycamorevanquished", stack: "1,000", chip: "🍗" },
  { rank: 4, name: "sycamorevanquished", stack: "1,000", chip: "🍗" },
  { rank: 6, name: "districtunguided", stack: "Eliminated", eliminated: true },
  { rank: 7, name: "overtonecallisto", stack: "Eliminated", eliminated: true },
];

const winnersPayoutWithBonus = {
  1: {
    amount: 1037.4,
    bonus: 0,
    ticket: false,
  },
  2: {
    amount: 543.4,
    bonus: 0,
    ticket: false,
  },
  3: {
    amount: 271.7,
    bonus: 0,
    ticket: false,
  },
  4: {
    amount: 222.3,
    bonus: 0,
    ticket: false,
  },
  5: {
    amount: 209.95,
    bonus: 0,
    ticket: false,
  },
  6: {
    amount: 185.25,
    bonus: 0,
    ticket: false,
  },
};
